export default __webpack_public_path__ + "static/media/placeholder-2.d3cba9e1.png";